import f from "./_isArray.mjs";
import s from "./_isInteger.mjs";
function m(t, i, r) {
  if (s(t) && f(r)) {
    var n = [].concat(r);
    return n[t] = i, n;
  }
  var e = {};
  for (var a in r)
    e[a] = r[a];
  return e[t] = i, e;
}
export {
  m as default
};
